<div class="container" fxLayout="row wrap" fxLayoutAlign="space-between start">
  <div class="configuration-panel" fxLayout="column" fxFlex="100" [fxFlex.gt-sm]="collapsed ? 100 : 64">
    <button fxShow="true" fxShow.lt-md="false" class="collapse" mat-mini-fab (click)="toggleCollapse()" [matTooltip]="collapsed ? 'Expand' : 'Collapse'">
      <mat-icon *ngIf="collapsed">keyboard_double_arrow_left</mat-icon>
      <mat-icon *ngIf="!collapsed">keyboard_double_arrow_right</mat-icon>
    </button>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.InProgress" class="mat-card-inline-sm banner-info" fxFlex="100">
      <mat-card-content><span class="text-info">Rendering your {{ productNames[renderedOutput.productName] }}...</span></mat-card-content>
    </mat-card>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Queued" class="mat-card-inline-sm banner-info" fxFlex="100">
      <mat-card-content *ngIf="renderedOutput?.queuePosition"><span class="text-info">Your {{ productNames[renderedOutput.productName] }} is positioned {{ renderedOutput.queuePosition }} in the queue for rendering...</span></mat-card-content>
      <mat-card-content *ngIf="!renderedOutput?.queuePosition"><span class="text-info">Your {{ productNames[renderedOutput.productName] }} is queued for rendering...</span></mat-card-content>
    </mat-card>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Failed" class="mat-card-inline-sm banner-warning" fxFlex="100">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <span class="text-warning">Your {{ productNames[renderedOutput.productName] }} failed, please try again...</span>
        <mat-icon class="link" matTooltip="Clear failure" (click)="clear()">clear</mat-icon>
      </mat-card-content>
    </mat-card>
    <mat-card class="mat-card-inline-sm">
      <mat-card-content fxLayout="row wrap">
        <div #modelContainer  fxFlex="100">
          <div id="viewer" [fxShow]="renderedOutput?.productName !== productNames.Plan && renderedOutput?.productName !== productNames.Render" class="viewer" fxFlex="100"
            [style.height.px]="productHeight" [style.width.px]="productWidth">
            <div id="panorama-top-overlay" class="panorama-top-overlay" fxLayout="row" fxLayoutAlign="space-between center">
              <div fxFlex="50" id="panorama-controls" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-icon *ngIf="artifactId" class="icon-display link" matTooltip="Open/Close Fullscreen" matTooltipPosition="below" (click)="toggleFullscreen()" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()" aria-hidden="false" aria-label="fullscreen">
                  fullscreen
                </mat-icon>
                <mat-icon *ngIf="deviceHasGyro" class="icon-display link" matTooltip="Toggle Gyro" (click)="toggleGyro()" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()" matTooltipPosition="below" aria-hidden="false" aria-label="toggleGyro">
                  3d_rotation
                </mat-icon>
                <mat-icon *ngIf="(groundFloorAvailable || firstFloorAvailable || secondFloorAvailable)" class="icon-display" [class.link]="!showFloorPlan" [class.disable-link]="showFloorPlan" matTooltip="Toggle Floorplan" (click)="toggleFloorplan()" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()" matTooltipPosition="below" aria-hidden="false" aria-label="toggleFloorplan">
                  map
                </mat-icon>
                <mat-icon *ngIf="artifactId" class="icon-display link" matTooltip="Share this location" (click)="copyDebugUrl()" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()" matTooltipPosition="below" aria-hidden="false" aria-label="shareLocation">
                  share_location
                </mat-icon>
                <ng-container *ngIf="isReleasePermitted && hasReleaseItems">
                  <mat-icon class="icon-display link" color="primary" matTooltip="Report an issue" (click)="addEditReleaseIssue()" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()" matTooltipPosition="below" aria-hidden="false" aria-label="reportAnIssue">
                    bug_report
                  </mat-icon>
                </ng-container>
                <div *ngIf="viewingAngle" class="icon-display link" matTooltip="Copy URL to clipboard.">
                  <small>{{ viewingAngle }}°</small>
                </div>
              </div>
              <div fxFlex="50" *ngIf="renderStatus" class="progress" fxLayout="row" fxLayoutAlign="end center">
                <div fxHide="false" fxHide.lt-md="true" class="description">{{ renderStatusDescription }}</div>
                <div class="panorama-loading-progress">
                  <div>
                    <mat-spinner [diameter]="40">
                    </mat-spinner>
                    <div class="loading-value">
                      {{ renderStatusProgress }}
                    </div>
                  </div>
                </div>
              </div>
              <div [fxShow]="showFloorPlan && (groundFloorAvailable || firstFloorAvailable || secondFloorAvailable)" class="panorama-overlay-floorplan" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()">
                <div>
                  <button *ngIf="groundFloorAvailable" mat-button (click)="selectFloorPlan(0)">
                    Ground
                  </button>
                  <button *ngIf="firstFloorAvailable" mat-button (click)="selectFloorPlan(1)">
                    First
                  </button>
                  <button *ngIf="secondFloorAvailable" mat-button (click)="selectFloorPlan(2)">
                    Second
                  </button>
                </div>
                <div [fxShow]="showFloorPlan && selectedFloorPlan === 0" id="ground-floor-plan"></div>
                <div [fxShow]="showFloorPlan && selectedFloorPlan === 1" id="first-floor-plan"></div>
                <div [fxShow]="showFloorPlan && selectedFloorPlan === 2" id="second-floor-plan"></div>
              </div>
            </div>
          </div>
          <model-viewer id="glb" [fxShow]="renderedOutput?.status === renderedOutputStatusEnum.Complete && renderedOutput?.productName === productNames.Plan" class="viewer"
            [style.height.px]="productHeight" [style.width.px]="productWidth"
            shadow-intensity="1" camera-controls touch-action="pan-y"
            [src]="renderedOutput?.situPlanUrl"
            data-js-focus-visible=""
            ar-status="not-presenting"
            alt="GLB preview"
            tone-mapping="aces">
          </model-viewer>
          <carousel *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Complete && renderedOutput?.productName === productNames.Render && renderedOutput?.situRenderUrls?.length > 0"
            [images]="renderedOutput?.situRenderUrls">
          </carousel>
        </div>
        <div *ngIf="renderedOutput && renderedOutput?.status === renderedOutputStatusEnum.Complete" class="w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center" class="image-comparison-container">
            <div class="source-artifacts-overlay" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
              <div>
                <button *ngIf="isSituUser" [color]="editorMode ? 'warn' : 'accent'" mat-mini-fab (click)="toggleEditorMode()" matTooltip="Editor mode">
                  <mat-icon class="link">pageview</mat-icon>
                </button>
                <button color="accent" mat-mini-fab (click)="browse(renderedOutput?.styleConfigTemplate?.id, renderedOutput?.homeConfigId)" matTooltip="View situVIEW history">
                  <mat-icon class="link">history</mat-icon>
                </button>
                <button (click)="share(true)" color="accent" mat-mini-fab matTooltip="Share situPORTAL">
                  <mat-icon class="link">content_copy</mat-icon>
                </button>
                <button (click)="share()" color="accent" mat-mini-fab matTooltip="Share situLINK">
                  <mat-icon class="link">share</mat-icon>
                </button>
                <button [fxShow]="renderedOutput?.productName !== productNames.Plan && renderedOutput?.productName !== productNames.Render" color="primary" mat-mini-fab (click)="setDefault()" matTooltip="Set your situVIEW default">
                  <mat-icon class="link">lock</mat-icon>
                </button>
                <button [fxShow]="renderedOutput?.productName !== productNames.Plan && renderedOutput?.productName !== productNames.Render" *ngIf="isSituUser || isAdmin" color="primary" mat-mini-fab (click)="setDefault(true)" matTooltip="Set global situVIEW default">
                  <mat-icon class="link">vpn_lock</mat-icon>
                </button>
              </div>
              <source-artifacts-menu colourOverride="info" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode"  *ngIf="renderedOutput?.sourceArtifacts" [sourceArtifacts]="renderedOutput.sourceArtifacts" [accessoryCodes]="incomingAccessoryCodes"></source-artifacts-menu>
            </div>
          </div>
          <div *ngIf="renderedOutput && renderedOutput?.status === renderedOutputStatusEnum.Complete" class="m-t-15" fxFlex="100" fxLayout="row">
            <div class="download-container" fxFlex="70" fxLayout="row wrap" fxLayoutAlign="start center">
              <mat-label fxHide.lt-lg>View</mat-label>
              <button mat-icon-button [disabled]="renderedOutput?.resStandardArtifactId === renderedOutput?.artifactId" [matTooltip]="viewButtonTooltip(renderedOutput?.resStandardArtifactId, 'Geometry Check')"
                [color]="renderedOutput?.resStandardArtifactId ? 'accent' : 'primary'"
                (click)="renderChild(productNames.Panorama, renderedOutput?.resStandardArtifactId)">
                <mat-icon class="option-icon">architecture</mat-icon>
              </button>
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <mat-icon *ngIf="!isParent">arrow_left</mat-icon>
              <button mat-icon-button *ngIf="isParent || renderedOutput?.resRaytracedDraftArtifactId === renderedOutput?.artifactId" [disabled]="renderedOutput?.resRaytracedDraftArtifactId === renderedOutput?.artifactId" [matTooltip]="viewButtonTooltip(renderedOutput?.resRaytracedDraftArtifactId, 'Draft')"
                [color]="renderedOutput?.resRaytracedDraftArtifactId ? 'accent' : 'primary'"
                (click)="renderChild(productNames.RayTracedDraft, renderedOutput?.resRaytracedDraftArtifactId)">
                <mat-icon class="option-icon">2k_plus</mat-icon>
              </button>
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <ng-container *ngIf="(isSituUser || isAdmin)">
                <button mat-icon-button *ngIf="isParent || renderedOutput?.resRaytracedArtifactId === renderedOutput?.artifactId" [disabled]="renderedOutput?.resRaytracedArtifactId === renderedOutput?.artifactId" [matTooltip]="viewButtonTooltip(renderedOutput?.resRaytracedArtifactId, 'RayTraced')"
                  [color]="renderedOutput?.resRaytracedArtifactId ? 'accent' : 'primary'"
                  (click)="renderChild(productNames.RayTraced, renderedOutput?.resRaytracedArtifactId)">
                  <mat-icon class="option-icon">4k_plus</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="!(isSituUser || isAdmin)">
                <button mat-icon-button *ngIf="isParent || renderedOutput?.resRaytracedArtifactId === renderedOutput?.artifactId" [disabled]="!renderedOutput?.resRaytracedArtifactId || renderedOutput?.resRaytracedArtifactId === renderedOutput?.artifactId" [matTooltip]="viewButtonTooltip(renderedOutput?.resRaytracedArtifactId, 'RayTraced')"
                  color="accent"
                  (click)="loadById(renderedOutput?.resRaytracedArtifactId)">
                  <mat-icon class="option-icon">4k_plus</mat-icon>
                </button>
              </ng-container>
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <ng-container *ngIf="(isSituUser || isAdmin)">
                <button mat-icon-button *ngIf="isParent || renderedOutput?.resRaytracedPlusArtifactId === renderedOutput?.artifactId" [disabled]="renderedOutput?.resRaytracedPlusArtifactId === renderedOutput?.artifactId" 
                  [matTooltip]="viewButtonTooltip(renderedOutput?.resRaytracedPlusArtifactId, 'RayTraced+')"
                  [color]="renderedOutput?.resRaytracedPlusArtifactId ? 'accent' : 'primary'"
                  (click)="renderChild(productNames.RayTracedPlus, renderedOutput?.resRaytracedPlusArtifactId)">
                  <mat-icon class="option-icon">8k_plus</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="!(isSituUser || isAdmin)">
                <button mat-icon-button *ngIf="isParent || renderedOutput?.resRaytracedPlusArtifactId === renderedOutput?.artifactId" [disabled]="!renderedOutput?.resRaytracedPlusArtifactId || renderedOutput?.resRaytracedArtifactId === renderedOutput?.artifactId" 
                  [matTooltip]="viewButtonTooltip(renderedOutput?.resRaytracedPlusArtifactId, 'RayTraced+')"
                  color="accent"
                  (click)="loadById(renderedOutput?.resRaytracedPlusArtifactId)">
                  <mat-icon class="option-icon">8k_plus</mat-icon>
                </button>
              </ng-container>   
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <button mat-icon-button *ngIf="isParent || renderedOutput?.resVrArtifactId === renderedOutput?.artifactId" [disabled]="!isSituUser || renderedOutput?.resVrArtifactId === renderedOutput?.artifactId" [matTooltip]="viewButtonTooltip(renderedOutput?.resVrArtifactId, 'situVR')"
                [color]="renderedOutput?.resVrArtifactId ? 'accent' : 'primary'"
                (click)="renderChild(productNames.VR, renderedOutput?.resVrArtifactId)">
                <mat-icon class="option-icon">vrpano</mat-icon>
              </button>
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <ng-container *ngIf="(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resInsightsArtifactId === renderedOutput?.artifactId"
                        [disabled]="renderedOutput?.resInsightsArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resInsightsArtifactId, 'Insights')"
                        [color]="renderedOutput?.resInsightsArtifactId ? 'accent' : 'primary'"
                        (click)="renderChild(productNames.Insights, renderedOutput?.resInsightsArtifactId)">
                  <mat-icon class="option-icon">insights</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="!(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resInsightsArtifactId === renderedOutput?.artifactId"
                        [disabled]="!renderedOutput?.resInsightsArtifactId || renderedOutput?.resInsightsArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resInsightsArtifactId, 'Insights')"
                        color="accent"
                        (click)="loadById(renderedOutput?.resInsightsArtifactId)">
                  <mat-icon class="option-icon">insights</mat-icon>
                </button>
              </ng-container>              
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <ng-container *ngIf="(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resPlanArtifactId === renderedOutput?.artifactId"
                        [disabled]="renderedOutput?.resPlanArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resPlanArtifactId, 'situPLAN')"
                        [color]="renderedOutput?.resPlanArtifactId ? 'accent' : 'primary'"
                        (click)="renderChild(productNames.Plan, renderedOutput?.resPlanArtifactId)">
                  <mat-icon class="option-icon">foundation</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="!(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resPlanArtifactId === renderedOutput?.artifactId"
                        [disabled]="!renderedOutput?.resPlanArtifactId || renderedOutput?.resPlanArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resPlanArtifactId, 'situPLAN')"
                        color="accent"
                        (click)="loadById(renderedOutput?.resPlanArtifactId)">
                  <mat-icon class="option-icon">foundation</mat-icon>
                </button>
              </ng-container>
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <ng-container *ngIf="(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resRenderArtifactId === renderedOutput?.artifactId"
                        [disabled]="renderedOutput?.resRenderArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resRenderArtifactId, 'situRENDER')"
                        [color]="renderedOutput?.resRenderArtifactId ? 'accent' : 'primary'"
                        (click)="renderChild(productNames.Render, renderedOutput?.resRenderArtifactId)">
                  <mat-icon class="option-icon">photo_camera</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="!(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resRenderArtifactId === renderedOutput?.artifactId"
                        [disabled]="!renderedOutput?.resRenderArtifactId || renderedOutput?.resRenderArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resRenderArtifactId, 'situRENDER')"
                        color="accent"
                        (click)="loadById(renderedOutput?.resRenderArtifactId)">
                  <mat-icon class="option-icon">photo_camera</mat-icon>
                </button>
              </ng-container>
              <mat-icon *ngIf="isParent">arrow_right</mat-icon>
              <ng-container *ngIf="(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resUnrealArtifactId === renderedOutput?.artifactId"
                        [disabled]="renderedOutput?.resUnrealArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resUnrealArtifactId, 'situHOME')"
                        [color]="renderedOutput?.resUnrealArtifactId ? 'accent' : 'primary'"
                        (click)="renderChild(productNames.Unreal, renderedOutput?.resUnrealArtifactId)">
                  <mat-icon class="option-icon">view_in_ar</mat-icon>
                </button>
              </ng-container>
              <!-- <ng-container *ngIf="!(isSituUser || isAdmin)">
                <button mat-icon-button 
                        *ngIf="isParent || renderedOutput?.resUnrealArtifactId === renderedOutput?.artifactId"
                        [disabled]="!renderedOutput?.resUnrealArtifactId || renderedOutput?.resUnrealArtifactId === renderedOutput?.artifactId"
                        [matTooltip]="viewButtonTooltip(renderedOutput?.resUnrealArtifactId, 'situHOME')"
                        color="accent"
                        (click)="loadById(renderedOutput?.resUnrealArtifactId)">
                  <mat-icon class="option-icon">view_in_ar</mat-icon>
                </button>
              </ng-container> -->
            </div>
            <div fxFlex="30" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
              <button *ngIf="isReleasePermitted" color="accent" mat-flat-button aria-label="Send to Live" (click)="sendToLive()" [disabled]="!renderedOutput || renderedOutput.isProduction || renderedOutput.parentRenderedOutputId">
                <mat-icon>verified</mat-icon>
                <span fxHide.lt-lg>Send to Live</span>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    
    <mat-card class="mat-card-inline-sm" fxLayout="row" fxFlex="100">
      <mat-card-content fxFlex="100" fxLayout="column" fxLayoutAlign="start start">
        <!-- {{ selectedHomeConfigId }} -->
        <div #homeConfiguration fxLayout="row" fxLayoutAlign="start center" class="m-b-20 w-100 text-warning" [class.text-success]="selectedHomeConfigId">
          Home Configuration
          <button [disabled]="!selectedHomeConfigId" color="primary" mat-icon-button matTooltip="browse similar home configurations" (click)="browse('', selectedHomeConfigId)">
            <mat-icon class="small-icon">search</mat-icon>
          </button>
          <situ-furnish-menu *ngIf="isFurnishUser" class="furnish-menu" [company]="selectedCompany" [home]="homeName" [ifcFiles]="ifcFiles" (selectedHomeIfcFileId)="onSelectedHomeIfcFileId($event)">
            <button [disabled]="!selectedHomeConfigId" color="primary" mat-icon-button matTooltip="furnish this home configuration">
              <mat-icon class="option-icon">chair</mat-icon>
            </button>
          </situ-furnish-menu>
        </div>
        <home-config-slim class="w-100"
          [incomingHomeConfigId]="renderedOutput?.homeConfigId"
          [lockedStaging]="true"
          [product]="panoramaProductName"
          (homeIdUpdates)="onHomeIdUpdates($event)"
          (homeConfigIdUpdates)="onHomeConfigIdUpdates($event)"
          (homeConfigUpdates)="onHomeConfigUpdates($event)">
        </home-config-slim>

        <div #styleSelections fxLayout="row" fxLayoutAlign="start center" class="m-b-20 text-warning" [class.text-success]="selectedStyleTemplateId">
          Style Selections
          <button [disabled]="!selectedStyleTemplateId" color="primary" mat-icon-button matTooltip="browse similar style configurations" (click)="browse(selectedStyleTemplateId, '')">
            <mat-icon class="small-icon">search</mat-icon>
          </button>
        </div>
        <style-config class="w-100" [canEditTemplates]="isAdmin || isSituUser" [canAddTemplates]="isAdmin || isSituUser"
          [allowScratchTemplates]="isSituUser && advancedMode"
          [incomingStyleConfigTemplateId]="renderedOutput?.styleConfigTemplate?.id"
          [incomingHomeId]="selectedHomeId"
          [backend]="false"
          [saveTemplate]="saveTemplateTrigger"
          [product]="panoramaProductName"
          (onStyleTemplateChange)="onStyleTemplateIdUpdates($event)"
          (onSavePendingChange)="onSavePendingUpdates($event)">
        </style-config>

        <div #configurationOptions fxLayout="row" fxLayoutAlign="start center" class="m-b-20 m-t-20 text-warning" [class.text-success]="selectedAccessoryBundleId">
          Accessories
        </div>
        <accessory-bundle-config class="w-100"
          [incomingAccessoryBundleId]="incomingAccessoryBundleId"
          [incomingBuildingInstructions]="incomingBuildingInstructions"
          [incomingAccessoryCodes]="incomingAccessoryCodes"
          [homeName]="homeName"
          (onAccessoryBundleChange)="onAccessoryBundleUpdates($event)">
        </accessory-bundle-config>

        <!-- Advanced (Situ users only) — every experimental control lives together, at the bottom -->
        <ng-container *ngIf="isSituUser">
          <div class="advanced-mode-bar w-100 m-b-20 m-t-20" fxLayout="row" fxLayoutAlign="start center">
            <mat-slide-toggle color="accent" [checked]="advancedMode" (change)="toggleAdvancedMode()"
              matTooltip="Experimental tools for one-off scratch renders">
              Advanced mode
            </mat-slide-toggle>
          </div>

          <ng-container *ngIf="advancedMode">
            <div fxLayout="row" fxLayoutAlign="start center" class="m-b-20">
              Configuration
            </div>
            <div class="advanced-mode-options w-100 m-b-20" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px" fxLayoutGap.lt-sm="0">
              <mat-form-field fxFlex fxFlex.lt-sm="100">
                <mat-label>Renderer</mat-label>
                <mat-select [(value)]="selectedRenderer">
                  <mat-option [value]="undefined">Default</mat-option>
                  <mat-option *ngFor="let renderer of renderers" [value]="renderer">{{ renderer }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field fxFlex fxFlex.lt-sm="100">
                <mat-label>Environment</mat-label>
                <mat-select [(value)]="selectedEnvironment">
                  <mat-option [value]="undefined">Default</mat-option>
                  <mat-option *ngFor="let env of environmentOptions" [value]="env.value">{{ env.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="scratch-pad w-100 m-b-20" fxLayout="row" fxLayoutAlign="start center">
              <button mat-stroked-button color="accent" (click)="openScratchPad()"
                [disabled]="!selectedHomeConfigId"
                matTooltip="Move themes in and out of your scratch template, then render it">
                <mat-icon>science</mat-icon> Open scratch pad
              </button>
            </div>
          </ng-container>
        </ng-container>

        <div class="w-100" fxLayout="row" fxLayoutAlign="end center">
          <div fxFlex="50" fxLayout="row" fxLayoutAlign="start center">
            <ul>
              <li [matTooltip]="selectedHomeConfigId ? 'Valid' : 'NOT valid'" (click)="scrollToHomeConfiguration()"><span class="link text-warning" [class.text-success]="selectedHomeConfigId">Home Configuration</span></li>
              <li [matTooltip]="selectedStyleTemplateId ? 'Valid' : 'NOT valid'" (click)="scrollToStyleSelections()"><span class="link text-warning" [class.text-success]="selectedStyleTemplateId">Style Selections</span></li>
              <li [matTooltip]="selectedAccessoryBundleId ? 'Valid' : 'Optional'" (click)="scrollToConfigurationOptions()"><span class="link text-warning" [class.text-success]="selectedAccessoryBundleId">Accessories</span></li>
              <li *ngIf="renderedOutput && renderedOutput?.status !== renderedOutputStatusEnum.Complete">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <span class="text-warning">situVIEW in progress</span>
                  <mat-icon class="link small-icon" matTooltip="Clear situVIEW in progress" (click)="clear()">clear</mat-icon>
                </div>
              </li>
            </ul>
          </div>
          <div class="h-100" fxFlex="50" fxLayout="row" fxLayoutAlign="end end">
            <button *ngIf="styleTemplateSavePending" matTooltip="Save Render Config" color="primary" mat-flat-button aria-label="Save Config" (click)="saveTemplate();">
              Save
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted"
              (click)="addToRelease('Single')" 
              color="accent" mat-icon-button matTooltip="Add configuration to release" aria-label="Add configuration to release">
              <mat-icon>add_box</mat-icon>
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted" 
              (click)="addToRelease('MasterFiles')" 
              color="accent" mat-icon-button matTooltip="Add configuration with all master files to release" aria-label="Add configuration with all master files to release">
              <mat-icon>queue</mat-icon>
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted" 
              (click)="addToRelease('Options')" 
              color="accent" mat-icon-button matTooltip="Add configuration with all selected options separately" aria-label="Add configuration with all selected options separately">
              <mat-icon>filter_none</mat-icon>
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted" 
              (click)="addFacadeToAllHomes()" [disabled]="findingFacadeHomes"
              color="accent" mat-icon-button matTooltip="Add this facade to release for every home that has it" aria-label="Add this facade to release for every home that has it">
              <mat-icon>dynamic_feed</mat-icon>
            </button>
            <button *ngIf="!styleTemplateSavePending" matTooltip="Start situVIEW Geometry Check render" color="primary" mat-icon-button
                [disabled]="!selectedHomeConfigId || !selectedStyleTemplateId ||
                renderedOutput?.status === renderedOutputStatusEnum.InProgress || renderedOutput?.status === renderedOutputStatusEnum.Queued || renderedOutput?.status === renderedOutputStatusEnum.Failed"
                (click)="render(productNames.Panorama);" >
                <mat-icon>architecture</mat-icon>
            </button>
            <button *ngIf="!styleTemplateSavePending" matTooltip="Start situVIEW draft render" color="primary" mat-flat-button
                [disabled]="!selectedHomeConfigId || !selectedStyleTemplateId ||
                renderedOutput?.status === renderedOutputStatusEnum.InProgress || renderedOutput?.status === renderedOutputStatusEnum.Queued || renderedOutput?.status === renderedOutputStatusEnum.Failed"
                (click)="render(productNames.RayTracedDraft);" >
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2px">
                  <span>Create situVIEW</span><mat-icon>2k_plus</mat-icon>
                </div>
            </button>
          </div>
        </div>  
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Complete" class="mat-card-inline-sm">
      <mat-card-content class="mat-card-inline-sm" fxFlex="100" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-accordion class="w-100 embed-headers-align">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                API for Devs
              </mat-panel-title>
              <mat-panel-description>
                Have more control with this API to place panoramas dynamically
              </mat-panel-description>
            </mat-expansion-panel-header>

            <pre class="language-markup"><code class="language-markup" [innerHtml]="renderedOutput?.prismApiCode"></code></pre>
            <div fxLayout="row" fxLayoutAlign="end center">
              <button color="accent" mat-flat-button (click)="copyToClipboard(renderedOutput?.apiCode)">Copy API Embed</button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>
    </mat-card>

    <home-config-list fxFlex="100" fxShow="false" fxShow.lt-md="true" [fxShow.gt-md]="collapsed" 
      [product]="panoramaProductName"
      [viewRenderedOutput]="renderedOutput"
      [refreshToken]="refreshToken"
      (selectedRenderedOutputId)="loadById($event)"
      (onIssueSelectClick)="onIssueSelect($event)">
    </home-config-list>
  </div>

  <div class="favourites-panel" [fxShow]="!collapsed" fxShow.lt-md="false" fxFlex="35">
    <home-config-list [product]="panoramaProductName"
      [viewRenderedOutput]="renderedOutput"
      [refreshToken]="refreshToken"
      (selectedRenderedOutputId)="loadById($event);"
      (onIssueSelectClick)="onIssueSelect($event)">
    </home-config-list>
  </div>
</div>
